import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  Center,
  FormControl,
  FormLabel,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Select,
  ModalFooter,
  VStack,
  Text,
  HStack,
  Tooltip,
  IconButton,
  useToast,
  Skeleton,
  SkeletonText,
  Grid,
  GridItem,
  FormErrorMessage,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEducationCourseAsync,
  selectJobEducationCourse,
} from "../../../JobPostingSlice/JobEducationCourse/JobEducationCourceSlice";
import { useForm } from "react-hook-form";
import {
  fetchJobEducationAsync,
  selectJobEducation,
} from "../../../JobPostingSlice/JobEducation/JobEducationSlice";
import {
  addJobEducationCourseSpecialtyAsync,
  deleteJobEducationCourseSpecialtyAsync,
  fetchEducationCourseSpecialtyAsync,
  selectJobEducationCourseSpecialty,
  updateJobEducationCourseSpecialtyAsync,
} from "../../../JobPostingSlice/JobEducationCourseSpecialty/JobEducationCourseSpecialtySlice";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

function JobEducationCourseSpecialty() {
  const dispatch = useDispatch();
  const toast = useToast();

  const jobEducationCourse = useSelector(selectJobEducationCourse);
  const jobEducation = useSelector(selectJobEducation);
  const specialty = useSelector(selectJobEducationCourseSpecialty);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [error, setError] = useState(null);
  const [editJobEducationCourse, setEditJobEducationCourse] = useState("");
  const [editJobEducationCourseSpecialty, setEditJobEducationCourseSpecialty] =
    useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobEducationCourse, setEditableJobEducationCourse] =
    useState(null);
  const [deletingEducationCourse, setDeletingEducationCourse] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(fetchJobEducationAsync()),
          dispatch(fetchEducationCourseAsync()),
          dispatch(fetchEducationCourseSpecialtyAsync()),
        ]);
      } catch (error) {
        toast({
          title: "Error loading data",
          description: "Failed to load course specialties data",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [dispatch, toast]);

  const handleDelete = async (uuid) => {
    setIsDeleting(true);
    try {
      await dispatch(deleteJobEducationCourseSpecialtyAsync(uuid));
      await dispatch(fetchEducationCourseSpecialtyAsync());

      toast({
        title: "Success",
        description: "Education course specialty deleted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });

      onClose2();
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to delete education course specialty",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const openDeleteModal = (job) => {
    setDeletingEducationCourse(job);
    dispatch(fetchEducationCourseAsync());
    onOpen2();
  };

  const handleSave = async (newJobEducationCourseSpecialty) => {
    setIsSubmitting(true);
    try {
      await dispatch(
        addJobEducationCourseSpecialtyAsync(newJobEducationCourseSpecialty)
      );
      await dispatch(fetchEducationCourseSpecialtyAsync());

      toast({
        title: "Success",
        description: "Education course specialty added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });

      onClose1();
      reset();
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to add education course specialty",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      console.error("Failed to add project", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (jobTitle) => {
    console.log("Job :", jobTitle);
    setEditableJobEducationCourse(jobTitle);
    setEditJobEducationCourse(jobTitle.title);
    setEditJobStatus(jobTitle.status);
    setEditJobEducationCourseSpecialty(jobTitle.core_job_education_course.uuid);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editJobEducationCourse.trim()) {
      setIsUpdating(true);
      try {
        await dispatch(
          updateJobEducationCourseSpecialtyAsync({
            uuid: editableJobEducationCourse.uuid,
            jobEducationCourseSpecialtyData: {
              title: editJobEducationCourse,
              status: editJobStatus,
              job_education_course_uuid: editJobEducationCourseSpecialty,
            },
          })
        );

        await dispatch(fetchEducationCourseSpecialtyAsync());

        toast({
          title: "Success",
          description: "Education course specialty updated successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });

        setEditableJobEducationCourse(null);
        setEditJobEducationCourse("");
        setEditJobStatus("");
        setEditJobEducationCourseSpecialty("");
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
        toast({
          title: "Error",
          description: "Failed to update education course specialty",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      } finally {
        setIsUpdating(false);
      }
    }
  };

  const TableSkeleton = () => (
    <>
      {[...Array(5)].map((_, index) => (
        <Tr key={index}>
          <Td>
            <Skeleton height="20px" />
          </Td>
          <Td>
            <Skeleton height="20px" />
          </Td>
          <Td>
            <Skeleton height="20px" />
          </Td>
          <Td>
            <HStack spacing={2}>
              <Skeleton height="32px" width="32px" />
              <Skeleton height="32px" width="32px" />
            </HStack>
          </Td>
        </Tr>
      ))}
    </>
  );

  return (
    <div
      className="min-h-screen bg-adminbg p-4 contentAdmin"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div>
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Education Course Specialties
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button colorScheme="blue" fontSize="medium" onClick={onOpen1}>
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add Job Education Course Specialty
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form onSubmit={handleSubmit(handleSave)}>
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                          <GridItem colSpan={2}>
                            <FormControl isInvalid={errors.title}>
                              <FormLabel>Education Specialty</FormLabel>
                              <Input
                                color="black"
                                placeholder="Enter Education Specialty"
                                {...register("title", {
                                  required: "This field is required",
                                })}
                                isDisabled={isSubmitting}
                              />
                              <FormErrorMessage>
                                {errors.title && errors.title.message}
                              </FormErrorMessage>
                            </FormControl>
                          </GridItem>

                          <GridItem colSpan={1}>
                            <FormControl isInvalid={errors.status}>
                              <FormLabel>Course Status</FormLabel>
                              <Select
                                placeholder="Select Course Status"
                                color="black"
                                borderColor="black"
                                {...register("status", {
                                  required: "This field is required",
                                })}
                                isDisabled={isSubmitting}
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </Select>
                              <FormErrorMessage>
                                {errors.status && errors.status.message}
                              </FormErrorMessage>
                            </FormControl>
                          </GridItem>

                          <GridItem colSpan={1}>
                            <FormControl isInvalid={errors.job_education_course_uuid}>
                              <FormLabel>Job Education Course</FormLabel>
                              <Select
                                color="black"
                                placeholder="Select Job Education Course"
                                {...register("job_education_course_uuid", {
                                  required: "This field is required",
                                })}
                                isDisabled={isSubmitting}
                              >
                                {Array.isArray(jobEducationCourse) &&
                                  jobEducationCourse.map((education) => (
                                    <option key={education.uuid} value={education.uuid}>
                                      {education.title}
                                    </option>
                                  ))}
                              </Select>
                              <FormErrorMessage>
                                {errors.job_education_course_uuid &&
                                  errors.job_education_course_uuid.message}
                              </FormErrorMessage>
                            </FormControl>
                          </GridItem>
                        </Grid>
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button
                        colorScheme="blue"
                        mr={3}
                        type="submit"
                        isLoading={isSubmitting}
                        loadingText="Saving..."
                      >
                        Save
                      </Button>
                      <Button onClick={onClose1} isDisabled={isSubmitting} variant="outline">
                        Cancel
                      </Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>

              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit Job Education Course Specialty
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>Education Specialty</FormLabel>
                            <Input
                              color="black"
                              placeholder="Enter Education Specialty"
                              value={editJobEducationCourse}
                              onChange={(e) => setEditJobEducationCourse(e.target.value)}
                              isDisabled={isUpdating}
                            />
                          </FormControl>
                        </GridItem>

                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel>Course Status</FormLabel>
                            <Select
                              placeholder="Select Course Status"
                              value={editJobStatus}
                              onChange={(e) => setEditJobStatus(e.target.value)}
                              color="black"
                              borderColor="black"
                              isDisabled={isUpdating}
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </Select>
                          </FormControl>
                        </GridItem>

                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel>Job Education Course</FormLabel>
                            <Select
                              color="black"
                              placeholder="Select Job Education Course"
                              value={editJobEducationCourseSpecialty}
                              onChange={(e) =>
                                setEditJobEducationCourseSpecialty(e.target.value)
                              }
                              isDisabled={isUpdating}
                            >
                              {Array.isArray(jobEducationCourse) &&
                                jobEducationCourse.map((education) => (
                                  <option key={education.uuid} value={education.uuid}>
                                    {education.title}
                                  </option>
                                ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                      </Grid>
                    </VStack>
                    {error && (
                      <Text color="red.500" mt={4} textAlign="center">
                        {error}
                      </Text>
                    )}
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button
                      colorScheme="blue"
                      mr={3}
                      onClick={handleUpdate}
                      isLoading={isUpdating}
                      loadingText="Updating..."
                    >
                      Update
                    </Button>
                    <Button
                      onClick={() => setIsEditModalOpen(false)}
                      isDisabled={isUpdating}
                      variant="outline"
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl">
                  <div className="p-4">
                    <h4 className="py-2">
                      Are you sure you want to delete "
                      {deletingEducationCourse?.title}"?
                    </h4>
                    <div className="w-full flex justify-center gap-2 mt-4">
                      <Button
                        colorScheme="red"
                        className="w-48"
                        onClick={() =>
                          handleDelete(deletingEducationCourse.uuid)
                        }
                        isLoading={isDeleting}
                        loadingText="Deleting..."
                      >
                        Delete
                      </Button>
                      <Button
                        colorScheme="red"
                        variant="outline"
                        className="w-48"
                        onClick={onClose2}
                        disabled={isDeleting}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>

          {/* Table Section */}
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">Course</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {isLoading ? (
                  <TableSkeleton />
                ) : specialty && specialty.length > 0 ? (
                  specialty.map((job) => (
                    <Tr key={job.id}>
                      <Td>{job?.core_job_education_course?.title}</Td>
                      <Td>{job.title}</Td>
                      <Td className="text-green-500">{job.status}</Td>
                      <Td>
                        <HStack spacing={2}>
                          <Tooltip label="Edit Specialties" placement="top">
                            <IconButton
                              icon={<EditIcon />}
                              colorScheme="blue"
                              size="sm"
                              onClick={() => handleEdit(job)}
                              aria-label="Edit industry"
                            />
                          </Tooltip>
                          <Tooltip label="Delete Specialties" placement="top">
                            <IconButton
                              icon={<DeleteIcon />}
                              colorScheme="red"
                              size="sm"
                              onClick={() => openDeleteModal(job)}
                              aria-label="Delete industry"
                            />
                          </Tooltip>
                        </HStack>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobEducationCourseSpecialty;